















































































































import { Vue, Component } from 'vue-property-decorator';
import PageLoading from '@/pages/showDetail/PageLoading.vue';
import PageContent from '@/components/common/edit/PageContent.vue';
import VoteList from '@/pages/showDetail/VoteTypeList.vue';
import GroupList from '@/pages/showDetail/GroupTypeList.vue';
import DistributeGroupList from '@/pages/showDetail/DistributeGroupTypeList.vue'
import RedPackageTypeList from '@/pages/showDetail/RedPackageTypeList.vue';
import LessonTypeList from '@/pages/showDetail/LessonTypeList.vue';
import RollTypeList from '@/pages/showDetail/RollTypeList.vue';
import BargainTypeList from '@/pages/showDetail/BargainTypeList.vue';
import TyTypeList from '@/pages/showDetail/TyTypeList.vue';
import SolitaireList from '@/pages/showDetail/SolitaireList.vue';
import GachaList from '@/pages/showDetail/GachaType.vue';
import DistributionList from '@/pages/showDetail/DistributionList.vue';
import fetch from '@/common/api/fetch';
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import CONFIG from '@/common/config';
import { GRADE, GENDER } from '@/common/constants';
import { AxiosPromiseData, Grade, Gender } from '@/common/interface';
import Lottie from 'lottie-web';
let host: string = CONFIG.localServerB;
if (process.env.NODE_ENV === 'production') {
  host = (CONFIG.serverB as any)[process.env.VUE_APP_DEPLOY_ENV as string];
}

const canUseNewApiTypeList = ['solitaireType', 'bargainType', 'lessonType', 'groupType','distributeGroupType'];

@Component({
  components: {
    'show-page-loading': PageLoading,
    'page-content': PageContent,
    'vote-list': VoteList,
    'group-list': GroupList,
    'distribute-group-list': DistributeGroupList,
    'redpackage-list': RedPackageTypeList,
    'lesson-list': LessonTypeList,
    'roll-list': RollTypeList,
    'bargain-list': BargainTypeList,
    'ty-list': TyTypeList,
    'solitaire-list': SolitaireList,
    'gacha-list': GachaList,
    'distribution-list': DistributionList,
  },
})
export default class XMShowDetailIndex extends Vue {
  totalCount: number = 0;
  showLoading: boolean = true;
  joinDetail: Array<Object> = [];
  showDetail: any = {};
  solitaireShowDetails: any = {};
  content: any = {};

  gradeArr: Grade[] = GRADE;
  genderArr: Gender[] = GENDER;
  templateType: string = ''; // 活动类型
  urlType: string | undefined = getUrlParam('urlType');
  getingDetail: boolean = false;
  isExist: boolean = true; // 是否存在
  channel: string = '';// 支付通道
  showGuideTip: boolean = false;

  ErrorCodeEnum: any = {
    REFUND_NOT_OPEN_WALLET: '商户未开通钱包功能，无法直接退回至用户账户，建议先使用主账号开通小麦收银钱包功能。',
    REFUND_NOT_ENOUGH: '小麦收银可退余额不足，无法直接退回至用户账户。',
    REFUND_MEMBER_NOT_SAME: '该交易不是当前商户号收款，无法直接退回至用户账户。',
    REFUND_OVER_DATE: '存在距今超过170天的交易，无法直接退回至用户账户。',
    REFUND_TIME_NOT_SUPPORT: '请于04:00~23:30时间段内操作小麦收银退款。',
    REFUND_CHECK_ACCOUNTS_FAIL: '当日未对账成功，无法直接退回至用户账户，建议晚点稍后重试。'
  }
  
  async mounted() {
    Lottie.loadAnimation({
      path: 'https://image.xiaomaiketang.com/xm/J7C3JdDjxZ.json',
      name: 'test',
      renderer: 'svg',
      loop: true,
      autoplay: true,
      container: document.getElementById('lottie-box') as HTMLElement,
      
    });

    await this.fetchShowData();

    if (this.templateType == 'gachaType' || this.templateType === 'distributeType' || this.urlType === 'distributeType'|| this.templateType == 'distributeGroupType') {
      await this.fetchNewTypeDetailData();
    } else if (this.templateType == 'groupType' ) {
      // 团购
      const param = {
        activityDetailSortType: 'SIGN_UP_DESC',
      };
      await this.fetchDetailData(param);
    } else if (this.templateType == 'lessonType') {
      // 微传单
      const param = {
        activityDetailSortType: 'SIGN_UP_DESC',
      };
      await this.fetchDetailData(param);
    } else if (this.templateType == 'solitaireType') {
      // 群接龙
      const param = {
        activityDetailSortType: this.showDetail.needPay ? 'PAY_TIME_DESC' : 'SIGN_UP_DESC',
      };
      await this.fetchDetailData(param);
    } else if (this.templateType == 'bargainType') {
      // 砍价
      const param = {
        activityDetailSortType: 'SIGN_UP_DESC',
      };
      await this.fetchDetailData(param);
    } else {
      await this.fetchDetailData();
    }

    var currentTime = new Date(); // 获取当前时间
    var targetTime = new Date("2024/04/02"); // 设置目标时间点
    // 将时间转换成毫秒数
    var currentMillis = currentTime.getTime();
    var targetMillis = targetTime.getTime();
 
    // 取消引导 三个月后（4.2）下线 
    if (window.localStorage.getItem(`cancelGuide_${this.templateType}`)!=='yes' && currentMillis < targetMillis) {
      this.showGuideTip = true;
    } else {
      this.showGuideTip = false;
    }

    this.$forceUpdate();
  }

  async fetchShowData() {
    // const res = await this._fetchData('public/businessShow/get');
    const res_new = await this._fetchData('anon/businessShow/getActivityContent');
    const { result } = res_new;
    if (result) {
      const { templateType } = result;
      this.showDetail = result;
      document.title = templateType === 'voteType' ? '参与详情' : '报名详情';
      this.templateType = templateType;
      this.urlType = templateType;
      this.channel = result.channel || '';
      this.content=JSON.parse(result.content)
    } else {
      this.isExist = false;
      this.showLoading = false;
      document.title = '详情页';
    }
  }

  async fetchDetailData(param?: any) {

    if (canUseNewApiTypeList.indexOf(this.templateType) < 0) {
      this._fetchData('public/businessShow/getXmShowUserListDetail', param).then((res: AxiosPromiseData) => {
        const {
          result: { data = [], totalCount = 0 },
        } = res;
        this.joinDetail = data;
        this.totalCount = totalCount;
        this.showLoading = false;
      });
    } else {
      this._fetchData('public/businessShow/getXmShowUserListDetail', param).then((res: AxiosPromiseData) => {
        const { pageVO, statVO } = res.result;
        const { records = [], total = '0' } = pageVO;
        this.joinDetail = records;
        this.showDetail = statVO;
        this.totalCount = Number(total);
        this.showLoading = false;
      });
    }
  }

  // 从扭蛋机开始逐渐采用新的api
  async fetchNewTypeDetailData(param?: any) {
    this.getingDetail = true;
    this._fetchData('public/businessShow/getStatSignIn', param).then((res) => {
      const { pageVO, statVO } = res.result;
      const { records = [], total = '0' } = pageVO;
      this.joinDetail = records;
      this.showDetail = statVO;
      this.totalCount = Number(total);
      this.showLoading = false;
      this.getingDetail = false;
    });
  }

  _fetchData(url: string, param?: any): Promise<any> {
    const broadcastId = getUrlParam('broadcastId');
    const data = {
      hasApply: true,
      ...param,
      pageNo: 0,
      pageSize: 0,
      activityId: broadcastId,
    };

    return fetch.Sales(url, data);
  }

  refreshPage(hasPaid: number) {
    this.templateType == 'gachaType' ? this.fetchNewTypeDetailData() : this.fetchDetailData({ hasApply: hasPaid });
  }
  closeGuideTip() {
    if (this.showGuideTip && this.joinDetail && this.joinDetail.length > 0) {
      this.showGuideTip = false;
      window.localStorage.setItem(`cancelGuide_${this.templateType}`, 'yes');
    }
  }
}
